export default "__VITE_ASSET__182e2507__"